export default __webpack_public_path__ + "static/media/logo.71d6687c.svg";